// Liste de tags pour suggestion automatique basée sur les profils LinkedIn
// Organisée par catégories pour faciliter le matching

const tagList = [
  // ========== SÉNIORITÉ ==========
  "junior",
  "confirmé",
  "senior",
  "expert",
  "lead",
  "staff",
  "architecte",
  "manager",
  "director",
  "head of",
  "c-level",
  "VP",
  "CTO",
  "CEO",
  "CFO",
  "COO",
  "CDO",
  "CISO",

  // ========== MÉTIERS TECH ==========
  // Développement
  "développeur",
  "developer",
  "fullstack",
  "frontend",
  "backend",
  "mobile",
  "web developer",
  "software engineer",
  "devops",
  "sre",
  "platform engineer",

  // Data & IA
  "data analyst",
  "data scientist",
  "data engineer",
  "data architect",
  "machine learning engineer",
  "machine learning",
  "ml engineer",
  "ai engineer",
  "mlops",
  "business intelligence",
  "bi analyst",
  "analytics engineer",
  "Site Reliability Engineer",

  // Product & Design
  "product manager",
  "product owner",
  "scrum master",
  "agile coach",
  "ux designer",
  "ui designer",
  "ux/ui designer",
  "product designer",
  "graphic designer",

  // Infrastructure & Sécurité
  "devops engineer",
  "cloud engineer",
  "infrastructure engineer",
  "security engineer",
  "cybersecurity",
  "pentester",
  "security analyst",
  "soc analyst",
  "network engineer",
  "system administrator",
  "sysadmin",

  // ========== TECHNOLOGIES ==========
  // Langages
  "javascript",
  "typescript",
  "python",
  "java",
  "go",
  "golang",
  "rust",
  "c++",
  "c#",
  "php",
  "ruby",
  "swift",
  "kotlin",
  "scala",

  // Frontend
  "react",
  "vue",
  "angular",
  "next.js",
  "nuxt",
  "svelte",
  "tailwind",
  "sass",

  // Backend
  "node",
  "node.js",
  "express",
  "nestjs",
  "django",
  "flask",
  "fastapi",
  "spring boot",
  "laravel",
  "rails",

  // Base de données
  "sql",
  "postgresql",
  "mysql",
  "mongodb",
  "redis",
  "elasticsearch",
  "dynamodb",
  "cassandra",

  // Cloud & DevOps
  "aws",
  "azure",
  "gcp",
  "google cloud",
  "docker",
  "kubernetes",
  "k8s",
  "terraform",
  "ansible",
  "jenkins",
  "gitlab ci",
  "github actions",
  "ci/cd",

  // Data & Analytics
  "tableau",
  "power bi",
  "looker",
  "metabase",
  "airflow",
  "dbt",
  "spark",
  "hadoop",
  "kafka",
  "snowflake",
  "databricks",

  // ========== MÉTIERS BUSINESS ==========
  // Vente & Commercial
  "commercial",
  "sales",
  "account manager",
  "account executive",
  "business developer",
  "sales manager",
  "sales director",
  "key account manager",
  "hunter",
  "closer",
  "sdr",
  "bdr",
  "sales ops",

  // Marketing & Communication
  "marketing",
  "digital marketing",
  "content manager",
  "community manager",
  "social media manager",
  "seo specialist",
  "sem specialist",
  "growth hacker",
  "growth marketing",
  "marketing automation",
  "brand manager",
  "communication manager",

  // Finance & Comptabilité
  "comptable",
  "accountant",
  "financial analyst",
  "controller",
  "financial controller",
  "treasury",
  "consolidation",
  "audit",
  "auditeur",
  "expert-comptable",
  "daf",
  "credit manager",

  // Conseil & Stratégie
  "consultant",
  "strategy consultant",
  "management consultant",
  "it consultant",
  "business analyst",
  "functional analyst",
  "business consultant",
  "change manager",

  // RH & Recrutement
  "recruteur",
  "recruiter",
  "talent acquisition",
  "hr manager",
  "hr business partner",
  "hrbp",
  "chargé de recrutement",
  "talent manager",
  "hr generalist",
  "payroll",
  "formation",

  // Juridique & Compliance
  "juriste",
  "legal counsel",
  "compliance officer",
  "dpo",
  "data protection",
  "contract manager",
  "legal manager",

  // Achats & Supply Chain
  "acheteur",
  "buyer",
  "procurement",
  "supply chain manager",
  "logistics manager",
  "category manager",

  // Customer Success & Support
  "customer success",
  "customer success manager",
  "csm",
  "account manager",
  "support",
  "technical support",
  "customer support",
  "help desk",

  // ========== SECTEURS D'ACTIVITÉ ==========
  "fintech",
  "insurtech",
  "healthtech",
  "edtech",
  "proptech",
  "legaltech",
  "adtech",
  "martech",
  "retail",
  "e-commerce",
  "saas",
  "b2b",
  "b2c",
  "marketplace",
  "banking",
  "insurance",
  "healthcare",
  "pharmaceutical",
  "energy",
  "telecom",
  "media",
  "entertainment",
  "gaming",
  "automotive",
  "aerospace",
  "luxury",
  "fashion",
  "consulting",
  "audit",
  "legal",

  // ========== COMPÉTENCES TRANSVERSES ==========
  // Méthodologies
  "agile",
  "scrum",
  "kanban",
  "lean",
  "six sigma",
  "prince2",
  "pmp",
  "safe",

  // Management & Leadership
  "team lead",
  "tech lead",
  "leadership",
  "management",
  "coaching",
  "mentoring",
  "hiring",
  "people management",

  // Soft Skills
  "communication",
  "négociation",
  "problem solving",
  "analytical thinking",
  "creativity",
  "autonomie",
  "teamwork",
  "adaptability",

  // ========== LANGUES ==========
  "anglais",
  "english",
  "bilingual",
  "bilingue",
  "français",
  "french",
  "espagnol",
  "spanish",
  "allemand",
  "german",
  "italien",
  "italian",
  "mandarin",
  "chinois",

  // ========== FORMATION & CERTIFICATIONS ==========
  "grande école",
  "école de commerce",
  "école d'ingénieur",
  "master",
  "mba",
  "bac+5",
  "bac+3",
  "licence",
  "phd",
  "doctorat",
  "aws certified",
  "azure certified",
  "gcp certified",
  "pmp certified",
  "scrum master certified",
  "cissp",
  "cisa",
  "cfa",

  // ========== TYPE DE POSTE ==========
  "cdi",
  "freelance",
  "contractor",
  "interim",
  "stage",
  "internship",
  "apprentissage",
  "alternance",
  "remote",
  "télétravail",
  "hybrid",
  "on-site",

  // ========== SPÉCIFICITÉS MÉTIER ==========
  // Marketing Digital
  "facebook ads",
  "google ads",
  "linkedin ads",
  "email marketing",
  "marketing automation",
  "hubspot",
  "salesforce",
  "crm",

  // E-commerce
  "shopify",
  "prestashop",
  "magento",
  "woocommerce",
  "marketplace management",

  // Product Management
  "roadmap",
  "backlog",
  "user stories",
  "product strategy",
  "product analytics",
  "a/b testing",
  "product-led growth",

  // Sales
  "prospection",
  "closing",
  "negotiation",
  "crm management",
  "pipeline management",
  "sales enablement",

  // Finance
  "financial modeling",
  "valuation",
  "m&a",
  "fp&a",
  "budgeting",
  "forecasting",
  "reporting",
  "ifrs",
  "gaap",

  // ========== TAILLE D'ENTREPRISE ==========
  "startup",
  "scale-up",
  "pme",
  "eti",
  "grand groupe",
  "corporate",
  "entreprise",

  // ========== TRAITS PROFESSIONNELS ==========
  "hands-on",
  "strategic",
  "operational",
  "international",
  "global",
  "multicultural",
  "entrepreneur",
  "intrapreneur",
  "transformation",
  "innovation",
  "growth",
  "scale",

  // ========== VILLES FRANÇAISES (>50k habitants) ==========
  "paris",
  "marseille",
  "lyon",
  "toulouse",
  "nice",
  "nantes",
  "montpellier",
  "strasbourg",
  "bordeaux",
  "lille",
  "rennes",
  "reims",
  "saint-étienne",
  "toulon",
  "le havre",
  "grenoble",
  "dijon",
  "angers",
  "nîmes",
  "villeurbanne",
  "clermont-ferrand",
  "le mans",
  "aix-en-provence",
  "brest",
  "tours",
  "amiens",
  "limoges",
  "annecy",
  "boulogne-billancourt",
  "perpignan",
  "metz",
  "besançon",
  "orléans",
  "saint-denis",
  "argenteuil",
  "rouen",
  "mulhouse",
  "montreuil",
  "caen",
  "nancy",
  "tourcoing",
  "roubaix",
  "nanterre",
  "avignon",
  "vitry-sur-seine",
  "créteil",
  "dunkerque",
  "poitiers",
  "asnières-sur-seine",
  "courbevoie",
  "versailles",
  "colombes",
  "fort-de-france",
  "aulnay-sous-bois",
  "saint-paul",
  "rueil-malmaison",
  "pau",
  "aubervilliers",
  "le tampon",
  "champigny-sur-marne",
  "antibes",
  "la rochelle",
  "saint-maur-des-fossés",
  "cannes",
  "calais",
  "béziers",
  "colmar",
  "bourges",
  "drancy",
  "mérignac",
  "saint-nazaire",
  "valence",
  "ajaccio",
  "issy-les-moulineaux",
  "villeneuve-d'ascq",
  "levallois-perret",
  "noisy-le-grand",
  "quimper",
  "la seyne-sur-mer",
  "antony",
  "troyes",
  "neuilly-sur-seine",
  "sarcelles",
  "vaulx-en-velin",
  "clichy",
  "ivry-sur-seine",
  "chambéry",
  "lorient",
  "montauban",
  "niort",
  "pessac",
  "saint-quentin",
  "cergy",
  "beauvais",
  "cholet",
  "vannes",
  "hyères",
  "fréjus",
  "maisons-alfort",
  "clamart",
  "pantin",
  "épinay-sur-seine",
  "meaux",
  "fontenay-sous-bois",
  "bondy",
  "chelles",
  "évry",
  "la roche-sur-yon",
  "arles",
  "bobigny",
  "saint-priest",
  "sevran",
  "sartrouville",
  "vincennes",
  "laval",
  "albi",
  "belfort",
  "châteauroux",
  "évreux",
  "charleville-mézières",
  "saint-brieuc",
  "saint-malo",
  "châlons-en-champagne",
  "carcassonne",
  "blois",
  "beaune",
  "alès",
  "bourg-en-bresse",
  "charleville",
  "tarbes",
  "castres",
  "joué-lès-tours",
  "angoulême",
  "valenciennes",
  "montélimar",
  "mâcon",
  "auxerre",
  "gap",
  "melun",
  "arras",
  "thionville",
  "douai",
  "brive-la-gaillarde",
  "cagnes-sur-mer",
  "salon-de-provence",
  "mantes-la-jolie",
  "grasse",
  "cherbourg",
  "villejuif",
];

export default tagList;
